import Structure from '@/features/companyBranches/pages/Structure/structure';
import { ReactFlowProvider } from '@xyflow/react';

const CompanyBranchesStructure = () => {
  return (
    <ReactFlowProvider>
      <Structure />
    </ReactFlowProvider>
  );
};

export default CompanyBranchesStructure;
